import CommonState from './CommonState'

export function getCommonState(code, list) {
  for (var common of list) {
    if (common.code === code) {
      return common
    }
  }
  return null
}

export const STATE_EMPTY = new CommonState(null, '-请选择-', 'Please Select')
export const STATE_UNCOMMIT = new CommonState(0, '未提交', 'Unconfirm')
export const STATE_PRE_COMMIT = new CommonState(11, '预提交', 'Pre Commit')
export const STATE_COMMITED = new CommonState(1, '已提交', 'Confirmed')
export const STATE_VERIFIED = new CommonState(2, '已审核', 'Verified')
export const STATE_REJECT = new CommonState(3, '已驳回', 'Reject')

export const OFFSET_STATE_NORMAL = new CommonState(0, '正常', 'Normal')
export const OFFSET_STATE_HEDGE = new CommonState(1, '红冲', 'Hedge')
export const OFFSET_STATE_BE_HEDGE = new CommonState(2, '被红冲', 'Be Hedge')

/**
 * 费用状态
 */
export const PAYMENT_CHARGE_STATES = new Set([
  STATE_UNCOMMIT,
  STATE_COMMITED,
  STATE_VERIFIED
])

/**
 * 费用状态
 */
export const CHARGE_STATES = new Set([
  STATE_UNCOMMIT,
  STATE_PRE_COMMIT,
  STATE_COMMITED,
  STATE_VERIFIED,
  STATE_REJECT
])

export const CONFIRM_STATE_UNCONFIRM = new CommonState(0, '未确认', 'Unconfirm')
export const CONFIRM_STATE_CONFIRMED = new CommonState(1, '已确认', 'Confirmed')

/**
 * 费用确认状态
 */
export const CONFIRM_STATES = new Set([
  CONFIRM_STATE_UNCONFIRM,
  CONFIRM_STATE_CONFIRMED
])

export const NOT_SHARED = new CommonState(0, '不分摊', 'Not Shared')
export const SHARE_CUBAGE = new CommonState(1, '根据体积', 'By Cubage')
export const SHARE_WEIGHT = new CommonState(2, '根据重量', 'By Weight')
export const SHARE_CHARGE_WEIGHT = new CommonState(3, '根据计费重量', 'By CW.')
export const SHARE_AVERAGE = new CommonState(4, '平均分配', 'Average')
export const SHARE_HANDWORK = new CommonState(99, '手动分配', 'Handwork')
export const SHARE_C_WEIGHT = new CommonState(5, '根据实际计费重量（空出）', 'By C_WEIGHT')
export const SHARE_QUANTITY = new CommonState(6, '根据件数', 'By quantity')

export const ACCOUNT_CUSTOMER = new CommonState('customer', '客户', 'Customer')
export const ACCOUNT_CARRIER = new CommonState('carrier', '承运人', 'Carrier')
export const ACCOUNT_BOOKING_AGENT = new CommonState('bookingAgent', '订舱代理/换单代理', 'Booking agent/Switch Bill agent')
export const ACCOUNT_BOOKING_AGENT_SINGLE = new CommonState('bookingAgent', '订舱代理', 'Booking agent')
export const ACCOUNT_CARRIER_AGENT = new CommonState('carrierAgent', '船代', 'Shipping agent')
export const ACCOUNT_OVERSEA_AGENT = new CommonState('overseaAgent', '目的港代理', 'Overseas agent')
export const ACCOUNT_CUSTOMS_BROKER = new CommonState('customsBroker', '报关行', 'Customs broker')
export const ACCOUNT_WAREHOUSE = new CommonState('warehouse', '仓库', 'Warehouse')
export const ACCOUNT_TRUCKING = new CommonState('trucking', '车队', 'Trucking company')
export const FORWARDING_AGENT = new CommonState('forwardingAgent', '发运代理', 'Forwarding agent')
export const TERMINAL_COMPANY = new CommonState('terminalCompany', '码头公司', 'terminal Company')
export const NOMINATED_AGENT = new CommonState('nominatedAgent', '指定货代理', 'Nominated agent')
export const EXCHANGE_AGENT = new CommonState('exchangeAgent', '换单代理', 'Exchange agent')
export const SHIPPER_ID = new CommonState('shipperId', '发货人', 'Shipper')
export const CONSIGNEE_ID = new CommonState('consigneeId', '收货人', 'Consignee')
export const NOITFY_ID = new CommonState('notifyId', '通知人', 'Notify')

/**
 * 费用分摊类型
 */
export const SHARE_CHARGE_SCHEMES = new Set([
  NOT_SHARED,
  SHARE_CUBAGE,
  SHARE_WEIGHT,
  SHARE_CHARGE_WEIGHT,
  SHARE_C_WEIGHT,
  SHARE_AVERAGE,
  SHARE_HANDWORK,
  SHARE_QUANTITY
])

/**
 * 费用分摊类型【排除手动分摊】
 */
export const SHARE_CHARGE_SCHEMES_NEW = new Set([
  NOT_SHARED,
  SHARE_CUBAGE,
  SHARE_WEIGHT,
  SHARE_CHARGE_WEIGHT,
  SHARE_C_WEIGHT,
  SHARE_AVERAGE,
  SHARE_QUANTITY
])

/**
 * 费用方案结算单位类型
 */
export const CHARGE_SCHEME_PARTNER_TYPES = new Set([
  ACCOUNT_CUSTOMER,
  ACCOUNT_CARRIER,
  ACCOUNT_BOOKING_AGENT,
  ACCOUNT_CARRIER_AGENT,
  ACCOUNT_OVERSEA_AGENT,
  ACCOUNT_CUSTOMS_BROKER,
  ACCOUNT_WAREHOUSE,
  ACCOUNT_TRUCKING,
  FORWARDING_AGENT,
  TERMINAL_COMPANY,
  NOMINATED_AGENT,
  SHIPPER_ID,
  CONSIGNEE_ID,
  NOITFY_ID
])

/**
 * 费用方案结算单位类型-海出
 */
export const CHARGE_SCHEME_PARTNER_TYPES_SE = new Set([
  ACCOUNT_CUSTOMER,
  ACCOUNT_CARRIER,
  ACCOUNT_BOOKING_AGENT_SINGLE,
  EXCHANGE_AGENT,
  ACCOUNT_CARRIER_AGENT,
  ACCOUNT_OVERSEA_AGENT,
  ACCOUNT_CUSTOMS_BROKER,
  ACCOUNT_WAREHOUSE,
  ACCOUNT_TRUCKING,
  FORWARDING_AGENT,
  TERMINAL_COMPANY,
  NOMINATED_AGENT,
  SHIPPER_ID,
  CONSIGNEE_ID,
  NOITFY_ID
])

export const CHARGE_TYPE_INTERNAL = new CommonState(0, '国内', 'Internal')
export const CHARGE_TYPE_OVERSEA = new CommonState(1, '国外', 'Oversea')

/**
 * 费用确认状态
 */
export const CHARGE_TYPES = new Set([
  CHARGE_TYPE_INTERNAL,
  CHARGE_TYPE_OVERSEA
])

export const CHARGE_ADJUSTMENT_EXPENSE = new CommonState(1, '调整费用', 'Adjustment fee')
export const CHARGE_NOT_ADJUSTED_EXPENSE = new CommonState(0, '非调整费用', 'Not Adjusted Expense')

/**
 * 费用调整状态
 */
export const CHARGE_ADJUSTMENT_STATES = new Set([
  CHARGE_ADJUSTMENT_EXPENSE,
  CHARGE_NOT_ADJUSTED_EXPENSE
])

export const CHARGE_SERVICE_TICKET_STATE_ISSUED = new CommonState(1, '已开确认单', 'Service ticket issued')
export const CHARGE_SERVICE_TICKET_STATE_UNISSUED = new CommonState(0, '未开确认单', 'Cargo_UnissuedServiceTicket')

/**
 * 代收垫付
 */
export const CHARGE_SERVICE_TICKET_STATES = new Set([
  CHARGE_SERVICE_TICKET_STATE_ISSUED,
  CHARGE_SERVICE_TICKET_STATE_UNISSUED
])

/**
 * 费用锁定状态
 */
export const LOCKED = new CommonState(1, '已锁定', 'Locked')
export const UN_LOCKED = new CommonState(0, '未锁定', 'UnLocked')
export const CHARGE_LOCKED_STATES = new Set([
  LOCKED,
  UN_LOCKED
])

export const FILTER_LOCKED = new CommonState(1, '已锁定费用', 'Locked Charge')
export const FILTER_UN_LOCKED = new CommonState(0, '未锁定费用', 'UnLocked Charge')
export const FILTER_CHARGE_LOCKED_STATES = new Set([
  FILTER_LOCKED,
  FILTER_UN_LOCKED
])

export const EAS_STATE_NO_SYNC = new CommonState(0, '未同步', 'Unsynchronized')
export const EAS_STATE_NO_APPROVE = new CommonState(1, '未审核', 'Unaudited')
export const EAS_STATE_APPROVED = new CommonState(2, '已审核', 'Reviewed')
export const EAS_STATE_DELETED = new CommonState(3, '已删除', 'Deleted')
export const EAS_STATE_SYNC_FAIL = new CommonState(4, '同步失败', 'Sync Fail')
export const EAS_STATE_SYNC = new CommonState(5, '已同步', 'Synchronized')

/**
 * EAS-费用状态
 */
export const EAS_CHARGE_STATES = new Set([
  EAS_STATE_NO_SYNC,
  EAS_STATE_NO_APPROVE,
  EAS_STATE_APPROVED,
  EAS_STATE_DELETED,
  EAS_STATE_SYNC_FAIL
])

/**
 * EAS-费用状态-全部
 */
export const ALL_EAS_CHARGE_STATES = new Set([
  EAS_STATE_NO_SYNC,
  EAS_STATE_NO_APPROVE,
  EAS_STATE_APPROVED,
  EAS_STATE_DELETED,
  EAS_STATE_SYNC_FAIL,
  EAS_STATE_SYNC
])

/**
 * 应收应付
 */
export const RECEIVABLE = new CommonState(true, '应收', 'Receivable')
export const PAYABLE = new CommonState(false, '应付', 'Payable')
export const RECEIVABLE_PAYABLE_TYPES = [RECEIVABLE, PAYABLE]

export const NOT_SENT = new CommonState(0, '未同步', 'Not sent')
export const HAS_BEEN_SENT = new CommonState(1, '已同步', 'has been sent')
export const SYNCHRONIZATION_FAILED = new CommonState(2, '同步失败', 'Synchronization failed')

export const ALL_LTS_STATUS = new Set([
  NOT_SENT,
  HAS_BEEN_SENT,
  SYNCHRONIZATION_FAILED
])

/**
 * 同步进度
 */
export const WE_HAVE_REFUSED = new CommonState(-3, '我方已拒绝', 'We have refused')
export const WE_HAVE_CONFIRMED = new CommonState(-2, '我方已确认', 'We have confirmed')
export const TO_BE_CONFIRMED_BY_US = new CommonState(-1, '待我方确认', 'To be confirmed by us')
export const TO_BE_CONFIRMED_BY_OTHER_PARTY = new CommonState(0, '待对方确认', 'To be confirmed by the other party')
export const THE_OTHER_PARTY_HAS_CONFIRMED = new CommonState(1, '对方已确认', 'The other party has confirmed')
export const THE_OTHER_PARTY_HAS_REFUSED = new CommonState(2, '对方已拒绝', 'The other party has refused')
export const SYNC_PROGRESS = [WE_HAVE_REFUSED, WE_HAVE_CONFIRMED, TO_BE_CONFIRMED_BY_US, TO_BE_CONFIRMED_BY_OTHER_PARTY, THE_OTHER_PARTY_HAS_CONFIRMED, THE_OTHER_PARTY_HAS_REFUSED]

/**
 * 费用同步撤回状态
 */
export const WE_RECALL_TO_BE_REFUSED = new CommonState(1, '待我方确认', 'To be confirmed by us')
export const WE_RECALL_HAVE_CONFIRMED = new CommonState(2, '我方已确认', 'We have confirmed')
export const TO_BE_RECALL_HAVE_REFUSED = new CommonState(3, '我方已拒绝', 'We have refused')
export const TO_BE_RECALL_TO_BE_REFUSED = new CommonState(4, '待对方确认', 'To be confirmed by the other party')
export const THE_OTHER_RECALL_HAVE_CONFIRMED = new CommonState(5, '对方已确认', 'The other party has confirmed')
export const THE_OTHER_RECALL_HAVE_REFUSED = new CommonState(6, '对方已拒绝', 'The other party has refused')
export const SYNC_RECALL_STATE = [WE_RECALL_TO_BE_REFUSED, WE_RECALL_HAVE_CONFIRMED, TO_BE_RECALL_HAVE_REFUSED, TO_BE_RECALL_TO_BE_REFUSED, THE_OTHER_RECALL_HAVE_CONFIRMED, THE_OTHER_RECALL_HAVE_REFUSED]

/**
 * 金蝶云星空同步状态
 */
export const JDYXK_NOT_SYNC = new CommonState(0, '未同步', 'Not synchronized')
export const JDYXK_SYNC_SUCCESS = new CommonState(1, '同步成功', 'Synchronized success')
export const JDYXK_SYNC_FAIL = new CommonState(2, '同步失败', 'Synchronized fail')
export const JDYXK_INVALID_SUCCESS = new CommonState(3, '作废成功', 'Invalid success')
export const JDYXK_INVALID_FAIL = new CommonState(4, '作废失败', 'Invalid fail')
export const JDYXK_SYNC_STATUS = [JDYXK_NOT_SYNC, JDYXK_SYNC_SUCCESS, JDYXK_SYNC_FAIL, JDYXK_INVALID_SUCCESS, JDYXK_INVALID_FAIL]

/**
 * 业务金蝶云星空同步状态
 */
export const JOB_JDYXK_NOT_SYNC = new CommonState(0, '未同步', 'Not synchronized')
export const JOB_JDYXK_SYNC_PART = new CommonState(1, '部分同步', 'Partial synchronization')
export const JOB_JDYXK_SYNC_ALL = new CommonState(2, '全部同步', 'Full synchronization')
export const JOB_JDYXK_SYNC_STATUS = [JOB_JDYXK_NOT_SYNC, JOB_JDYXK_SYNC_PART, JOB_JDYXK_SYNC_ALL]

/**
 * 业务金蝶云星空同步状态-费用
 */
export const CHARGE_JDYXK_SYNC_STATUS = [JDYXK_NOT_SYNC, JDYXK_SYNC_SUCCESS, JDYXK_SYNC_FAIL]

/**
 * 中邮接口发送状态
 */
export const ZY_INTERFACE_NOT_PUSH = new CommonState(1, '未发送', 'Not push')
export const ZY_INTERFACE_PUSH_SUCCESS = new CommonState(2, '发送成功', 'Push suceess')
export const ZY_INTERFACE_PUSH_FAIL = new CommonState(3, '发送失败', 'Push fail')
export const ZY_INTERFACE_PUSH_STATUS = [ZY_INTERFACE_NOT_PUSH, ZY_INTERFACE_PUSH_SUCCESS, ZY_INTERFACE_PUSH_FAIL]

/**
 * 上海虹迈对接用友同步状态
 */
export const HM_YONGYOU_NOT_SYNC = new CommonState(0, '未同步', 'Not synchronize')
export const HM_YONGYOU_SYNC_SUCCESS = new CommonState(1, '已同步', 'Synchronized')
export const HM_YONGYOU_SYNC_FAIL = new CommonState(2, '同步失败', 'Synchronize fail')
export const HM_YONGYOU_SYNC_STATUS = [HM_YONGYOU_NOT_SYNC, HM_YONGYOU_SYNC_SUCCESS, HM_YONGYOU_SYNC_FAIL]

export const QL_KD_NOT_SYNC = new CommonState(0, '未同步', 'Not synchronize')
export const QL_KD_SYNC_SUCCESS = new CommonState(1, '已同步', 'Synchronized')
export const QL_KD_SYNC_FAIL = new CommonState(2, '同步失败', 'Synchronize fail')
export const QL_KD_SYNC_STATUS = [QL_KD_NOT_SYNC, QL_KD_SYNC_SUCCESS, QL_KD_SYNC_FAIL]

export const ALLOCATION_NATURE = new CommonState(0, '虚拟分摊', 'Virtual Allocation')

/**
 * 分摊性质
 */
export const ALLOCATION_NATURES = new Set([
  ALLOCATION_NATURE
])

/**
 * 来源
 * @type {CommonState}
 */
export const ETOWER_ONE = new CommonState(0, 'eTowerOne', 'eTowerOne')

/**
 * 成本类型
 * @type {CommonState}
 */
export const UN_CONFIRM = new CommonState(-1, '不确定', 'undefined')
export const UN_SELECTED = new CommonState(0, '未选择', 'unselected')
export const UN_PAID = new CommonState(1, '未付', 'Unpaid')
export const PAID = new CommonState(2, '已付', 'Paid')

export const COST_TYPES = [UN_SELECTED, UN_PAID, PAID]
// 费用显示列使用
export const CHARGE_DROP_COST_TYPES = [UN_PAID, PAID]
// 显示列使用
export const COLUMNS_COST_TYPES = [UN_CONFIRM, UN_PAID, PAID]

/**
 * 对账状态
 */
export const RECONCILIATION_STATE_NOT = new CommonState(0, '未对账', 'Not reconciled')
export const RECONCILIATION_STATE_SAME = new CommonState(1, '对账一致', 'Amount Same')
export const RECONCILIATION_STATE_NOT_SAME = new CommonState(2, '对账不一致', 'Not Amount Same')
export const RECONCILIATION_STATE_PERSON_CHECK = new CommonState(3, '手动完成', 'Person Check Success')
export const RECONCILIATION_STATE_DIFF_CONFIRM = new CommonState(4, '已调整确认', 'Adjusted and confirmed')

export const RECONCILIATION_STATES = new Set([
  RECONCILIATION_STATE_NOT,
  RECONCILIATION_STATE_SAME,
  RECONCILIATION_STATE_NOT_SAME,
  RECONCILIATION_STATE_PERSON_CHECK,
  RECONCILIATION_STATE_DIFF_CONFIRM
])

/**
 * 对账调整状态
 */
export const RECONCILIATION_ADJUST_STATE_NOT = new CommonState(1, '未调整', 'Unadjusted')
export const RECONCILIATION_ADJUST_STATE_PART = new CommonState(2, '部分调整', 'Partial adjustment')
export const RECONCILIATION_ADJUST_STATE_ALL = new CommonState(3, '全部调整', 'All adjustments')
export const RECONCILIATION_ADJUST_STATE_NONEED = new CommonState(4, '无需调整', 'No need to adjust')

export const RECONCILIATION_ADJUST_STATES = new Set([
  RECONCILIATION_ADJUST_STATE_NOT,
  RECONCILIATION_ADJUST_STATE_PART,
  RECONCILIATION_ADJUST_STATE_ALL,
  RECONCILIATION_ADJUST_STATE_NONEED
])
